export const RCFA_OVERVIEW_WIDGET_NAMESPACE = 'widget.rcfa-overview'
